import BaseService from "../BaseService";
import _ from "lodash";

class VoucherService extends BaseService {

    get = async (code) => {
        var data = await this._api.get(`/store/voucher/get`, { params: { code } });
        return data;
    };

    check = async (code, cart_id) => {
        var data = await this._api.get(`/store/voucher/check`, { params: { code ,cart_id} });
        return data;
    };

    publicList = async ({ cart_id, info } = {}) => {
        var data = await this._api.get(`/store/voucher/public_list`, { params: { cart_id, info } });
        return data;
    };


}
export default VoucherService;
